/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFoggyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-foggy"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M18 19.5Q17.5 19.5 17.13 19.13Q16.75 18.75 16.75 18.25Q16.75 17.73 17.13 17.36Q17.5 17 18 17Q18.52 17 18.89 17.36Q19.25 17.73 19.25 18.25Q19.25 18.75 18.89 19.13Q18.52 19.5 18 19.5ZM7 23Q6.5 23 6.13 22.63Q5.75 22.25 5.75 21.75Q5.75 21.23 6.13 20.86Q6.5 20.5 7 20.5Q7.53 20.5 7.89 20.86Q8.25 21.23 8.25 21.75Q8.25 22.25 7.89 22.63Q7.53 23 7 23ZM6 19.5Q5.5 19.5 5.13 19.13Q4.75 18.75 4.75 18.25Q4.75 17.73 5.13 17.36Q5.5 17 6 17L15 17Q15.53 17 15.89 17.36Q16.25 17.73 16.25 18.25Q16.25 18.75 15.89 19.13Q15.53 19.5 15 19.5ZM10 23Q9.5 23 9.13 22.63Q8.75 22.25 8.75 21.75Q8.75 21.23 9.13 20.86Q9.5 20.5 10 20.5L17 20.5Q17.52 20.5 17.89 20.86Q18.25 21.23 18.25 21.75Q18.25 22.25 17.89 22.63Q17.52 23 17 23ZM7.5 16.07Q5.08 16.07 3.38 14.38Q1.68 12.68 1.68 10.25Q1.68 8.1 3.09 6.47Q4.5 4.85 6.58 4.5Q7.42 3.05 8.85 2.24Q10.28 1.43 12 1.43Q14.28 1.43 16 2.89Q17.73 4.35 18.2 6.47Q19.95 6.72 21.14 8.06Q22.32 9.4 22.32 11.25Q22.32 13.25 20.91 14.66Q19.5 16.07 17.5 16.07Z" fill={color} />
    </svg>
  );
}
